export const ALLOCATIONS = "allocations";
export const SENDER_ZONE = "senderZoneId";
export const SENDER_BLOCK = "senderBlockId";
export const RECEIVER_ZONE = "receiverZoneId";
export const RECEIVER_BLOCK = "receiverBlockId";
export const RECEIVER_PROPERTY = "receiverPropertyId";
export const VALUE = "allocationValue";
export const RULE_NAME = "ruleName";